import { Badge } from '@/shared/ui/badge';
import { ContractStatus } from '../utils/types';
import { getStatusBadgeClass, getStatusLabel } from '../utils/contractStatus';
import { cn } from '@/shared/lib/utils';

interface ContractStatusBadgeProps {
  status: ContractStatus;
  className?: string;
}

export const ContractStatusBadge = ({ status, className }: ContractStatusBadgeProps) => {
  return (
    <Badge
      className={cn(
        'whitespace-nowrap px-3 py-1 text-xs font-semibold tracking-wide shadow-sm transition-transform hover:-translate-y-[1px] hover:shadow-md',
        getStatusBadgeClass(status),
        className
      )}
      variant="outline"
    >
      {getStatusLabel(status)}
    </Badge>
  );
};
